import { Textarea } from '@/components/common/Textarea'
import { CheckboxGroup } from '@/components/common/CheckboxGroup'
import { StepShell } from '../StepShell'
import { TREATMENT_OPTIONS } from '@/lib/constants'

const DEFAULT = { treatments: [], plan_text: '' }

export function TreatmentPlanStep({ value, onChange, errors = {} }) {
  const v = { ...DEFAULT, ...(value || {}) }
  const set = (patch) => onChange?.({ ...v, ...patch })

  return (
    <StepShell
      eyebrow="Section 11 — Phase 4"
      title="Treatment plan"
      description="Select the planned procedures. Add a free-text note for sequencing or specifics."
    >
      <CheckboxGroup
        label="Planned treatments"
        options={TREATMENT_OPTIONS}
        value={v.treatments}
        onChange={(arr) => set({ treatments: arr })}
        columns={2}
        error={errors.treatments}
      />
      <Textarea
        label="Plan notes"
        rows={4}
        value={v.plan_text}
        onChange={(e) => set({ plan_text: e.target.value })}
        placeholder={'Optional. e.g.\n• RCT wrt 36 first, then crown placement\n• Recall in 7 days'}
        hint="Pick at least one treatment above or write a note here."
      />
    </StepShell>
  )
}
